import React, { useState, useEffect } from 'react'
import { Button, Icon, Image, Menu } from 'semantic-ui-react'
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { makeStyles } from '@mui/styles';
import { connect } from 'react-redux';
import './Navbar.scss'
import logo_shield from '../../assets/logo_shield.svg'
import menu_burguer from '../../assets/menu_burguer.png'
import user from '../../assets/user.svg'
import { withRouter } from 'react-router-dom'
import shield_light from '../../assets/4.svg'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import logo from '../../assets/logo.svg'
import fbConfig from '../../config/fbConfig'
import { setNullUid, signOut } from '../../redux/actions/auth'
import { changeModeUser, getDataProfile } from '../../redux/actions/user';
import { getSubscriptionOfUser } from '../../extensions/stripe';
import { toast } from 'react-toastify';
import { logout } from '../../functions'

const Navbar = props => {

    const { data } = props;
    const [login, setLogin] = useState(null);
    const [open, setOpen] = useState(false);
    const [balance, setBalance] = useState(null)
    const [openMenu, setOpenMenu] = useState(false)


    useEffect(() => {
        
        fbConfig.auth().onAuthStateChanged(user => {
            if(user) {
                setLogin(user)
                props.getDataProfile();

                // Calculamos los puntos totales y el balance
                if(data && data.shield_points && data.shield_points.length > 0 && !balance) {
                    setBalance(data.shield_points[data.shield_points.length - 1].points)
                }

            }else{
                setLogin(null)
                props.history.push('/signin')
            }
        })

    }, [login, data])

    const handleOpen = () => setOpen(!open);

    // Ir a inicio de sesion
    const goSignIn = () => {
        props.history.push('/signin')
    }

    const signOut = async () => {
        await logout()
    }

    // Ir a registro
    const goSignUp = () => {
        props.history.push('/signup')
    }

    const goPrivacity = () => {
        props.history.push('/privacity')
    }

    const goToProfile = () => {
        props.history.push('/profile')
    }

    const goHome = () => {
        props.history.push('/')
    }


    // Vamos a la wallet
    const goWallet = () => {
        props.history.push('/wallet')
    }

    // Go to FAQ'S
    const goToFaq = () => {
        window.location.assign("https://www.shield-data.com/es/faq")
    }

    // Estilos de material ui
    const useStyles = makeStyles({
        root: {
            background: '#68bbe3',
            border: 0,
            borderRadius: 30,
            position: 'absolute',
            top: '10%',
            right: '2%',
            width: 300,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
            color: 'white',
            padding: ' 15px 30px',
        },
    });

    const classes = useStyles();

    return (
        <div className='navbar'>
            <div className='navbar_image'>
                <Image src={shield_light} />
            </div>

            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className={classes.root}>
                    <PopUp 
                        goPrivacity={goPrivacity} 
                        balance={balance} 
                        changeModeUser={props.changeModeUser}
                        dataUser={data}
                        signOut={signOut}
                        goWallet={goWallet}
                        goToProfile={goToProfile} />
                </Box>
            </Modal>

            <div className='navbar_right'>
                <div className='menu'>
                    <span onClick={goHome}>Inicio</span>
                    <span onClick={goWallet}>Monetización</span>
                    <span onClick={goPrivacity}>Privacidad</span>
                    <span onClick={goToFaq}>FAQ</span>
                </div>

                {   !login || !data ?
                    <div className='navbar_right_auth'>
                        <Button className='btn_blue' onClick={goSignIn}>
                            Iniciar sesión
                        </Button>
                        <Button className='btn_white' onClick={goSignUp}>
                            Registrarse
                        </Button>
                    </div> :
                    login && data &&
                    <div className='navbar_right_auth'>
                        <Button className='btn_profile' onClick={() => props.history.push('/profile')}>
                            <Image src={user} />
                            {data.name}
                        </Button>
                        <Button className='btn_balance' onClick={signOut}>
                            Cerrar sesión
                        </Button>
                        
                    </div>
                }
            </div>
            <div className='navbar_right_responsive'>
                <div className='menu'>
                    <img src={menu_burguer} style={{ width: '20px', height: '20px', marginLeft: '5%' }} onClick={() => setOpenMenu(!openMenu)}/>
                    <ul style={{ display: openMenu === true ? 'block' : 'none'  }}>
                        <li onClick={goHome}>Inicio</li>
                        <li onClick={goWallet}>Monetización</li>
                        <li onClick={goPrivacity}>Privacidad</li>
                        <li onClick={goToFaq}>FAQ</li>
                    </ul>
                </div>

                <div className='navbar_right_responsive_image'>
                    <Image src={shield_light} />
                </div>


                {   
                    login && data &&
                    <PowerSettingsNewIcon fontSize='small' style={{ marginRight: '5px', color: 'white', position: 'absolute', right: '5%' }} onClick={signOut}/>
                }
            </div>
            

        </div>
    )
}

// POP UP
function PopUp(props) {

    const { goPrivacity, balance, changeModeUser, dataUser, goWallet, signOut, goToProfile } = props

    const [mode, setMode] = useState(dataUser ? dataUser.mode : 'rewards')
    const [subscription, setSubscription] = useState(null)
    const [errorSubs, setErrorSubs] = useState(null)

    useEffect(() => {
        loadSubscription()
    }, [])

    const loadSubscription = async () => {
        const response = await getSubscriptionOfUser();
        if(response && response.role) {
            setSubscription(response.role)
        }
    }

    // Cambiar de modo
    const changeMode = mode => {
        setMode(mode)
        changeModeUser(mode)
    }

    const setErrorSubscription = () => {
        setErrorSubs('Necesitas la suscripcion Gold')
    }

    // Funcion para copiar el texto
    const copyText = async () => {

        const content = document.getElementById('linkShield');

        await navigator.clipboard.writeText(content.textContent);
        
        toast.success('Enlace copiado correctamente', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    }

    // Estilos de material ui
    const useStyles = makeStyles({
        header_hr: {
            width: '1px',
            height: '35px',
            display: 'flex',
            alignSelf: 'center',
            border: 'none',
            color: 'white',
            opacity: '0.5',
            background: 'white',
            marginLeft: '4px',
            marginRight: '4px'
        },
        p: {
            fontSize: '35px',
            margin: '0',
            letterSpacing: '0px'
        },
        buttons: {
            display: 'flex',
            width: '50%',
            justifyContent: 'space-between',
            borderRadius: '20px',
            height: 'min-content',
            backgroundColor: 'white'
        },
        active: {
            backgroundColor: '#055c9d',
            color: 'white',
            width: '55%',
            borderRadius:'20px',
            fontSize: 'x-small',
            padding: '8px 10px',
            border: 'none',
            transition: '0.2s'
        },
        disabled: {
            color: '#333333',
            backgroundColor: 'white',
            border: 'none',
            width: '45%',
            borderRadius: '20px',
            fontSize: 'x-small',
            padding: '8px 10px',
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
        },
        btn_pref: {
            display: 'flex',
            borderRadius: '20px',
            paddingTop: '10px',
            border: 'none',
            paddingBottom: '10px',
            width: "100%",
            color: '#41aee4',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
            background: 'white',
            justifyContent: 'center',
            fontWeight: 'bolder',
            marginTop: '10px',
            marginBottom: '10px',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        btn_account: {
            display: 'flex',
            borderRadius: '20px',
            paddingTop: '10px',
            border: 'none',
            paddingBottom: '10px',
            width: "70%",
            marginTop: '10px',
            color: '#41aee4',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
            background: 'white',
            justifyContent: 'center',
            fontWeight: 'bolder',
            marginBottom: '10px',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        btn_wallet: {
            display: 'flex',
            borderRadius: '20px',
            paddingTop: '10px',
            border: 'none',
            paddingBottom: '10px',
            width: "100%",
            fontWeight: 'bolder',
            color: '#41aee4',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
            background: 'white',
            justifyContent: 'center',
            marginBottom: '20px',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        btn_rewards: {
            display: 'flex',
            borderRadius: '20px',
            paddingTop: '10px',
            border: 'none',
            paddingBottom: '10px',
            width: "60%",
            color: '#00D4FC',
            background: 'white',
            justifyContent: 'center',
            marginBottom: '15px',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        switches: {
            display: 'flex',
            alignItems: 'center',
            width: '60%',
            justifyContent: 'flex-start',
            marginBottom: '0',
            marginTop: '0',

            '& span': {
                color: 'white',
                fontWeight: '200',
                fontSize: 'medium',
                marginBottom: '0',
                marginTop: '0',
            }
        },
        cards: {
            display: 'flex',
            justifyContent: 'space-between',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
            background: 'white',
            alignItems: 'center',
            borderRadius: '5px',
            padding: '12px 20px',
            width: '100%',
            marginTop: '10px',
        },
        cards_2: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
            background: 'white',
            borderRadius: '10px',
            padding: '12px 20px',
            width: '90%',
            marginBottom: '20px'
        },
        cards_btn_active: {
            backgroundColor: '#055c9d',
            color: 'white',
            width: 'max-content',
            borderRadius:'20px',
            fontSize: 'small',
            padding: '8px 10px',
            border: 'none',
            transition: '0.2s',
            '&:hover': {
                cursor: 'pointer'
            }
        },
        header: {
            display: 'flex',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '10px'
        },
        btn_logout: {
            display: 'flex',
            background: 'transparent',
            color: 'white',
            fontWeight: 'bolder',
            alignItems: 'center',
            border: 'none'
        }
    });
    const classes = useStyles();

    return (
        <div className='popup'>
            <div className='popup_header' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div 
                    className='popup_header_logo'
                    style={{ display: 'flex' }}>
                    <Image src={shield_light} style={{ width: '100px', margin: '0' }} />
                </div>
                
            </div>
            <div className={classes.header}>
                <span style={{ fontWeight: 'bolder', fontSize: '20px', color: 'white', marginRight: '10px', marginTop: '0' }}>
                    DSH
                </span>
                <span style={{ fontWeight: '200', fontSize: '20px', color: 'white' }}>
                    ¡Ya disponibles!
                </span>
            </div>
            <div className={classes.content}>
                
                <Button 
                    className={classes.btn_pref} 
                    onClick={goPrivacity}>
                    Cambiar preferencias
                </Button>
                <Button 
                    className={classes.btn_wallet} 
                    onClick={goWallet}>
                    Ver cartera virtual
                </Button>

                <span style={{ marginTop: '5px', color: 'white', fontWeight: 'bolder' }}>Cuenta</span>

                <div className={classes.cards}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Image src={'/blue_shield.png'} style={{ width: '35px', marginRight: '10px', marginTop: '5px', marginLeft: '20px' }} />
                    </div>
                    <span style={{fontSize: '22px', color: '#41aee4', fontWeight: 'bolder' }} >{ balance ? `${balance},00` : null }</span>
                    <span style={{ fontSize: '12px', color: '#41aee4', fontWeight: '300',
                                     textAlign: 'center', marginTop: '15px' }}>
                        <b style={{ color: '#41aee4', fontSize: '22px' }}>DSH</b>
                        <br />
                        Shield Tokens
                    </span>
                </div>

                <Button 
                    className={classes.btn_account} 
                    onClick={goToProfile}>
                    Gestionar cuenta
                </Button>

                <Button className={classes.btn_logout} onClick={signOut}>
                    <PowerSettingsNewIcon fontSize='small' style={{ marginRight: '5px', color: 'white' }}/>
                    Cerrar sesión
                </Button>
                
            </div>
        </div>
    )
  
}

const mapStateToProps = state => {

    const data = state.user.data

    return {
        data
    }

}

const mapDispatchToProps = dispatch => {
    return {
        getDataProfile: () => dispatch(getDataProfile()),
        signOut: () => dispatch(signOut()),
        changeModeUser: mode => dispatch(changeModeUser(mode)),
        setUidNull: () => dispatch(setNullUid())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navbar))
